export class ContentService {
    constructor($resource, ApiService) {
        'ngInject';

        this.$resource = $resource;
		this.apiService = ApiService;
    }
}


// WEBPACK FOOTER //
// ./src/app/common/components/content-template/content-template.service.js